import { USER_AUTH_STATE_KEY } from '@/App/constants/storageKeys';
import { USER_AUTH_STATE_ANONYMOUS } from '@/App/constants/storageValues';
import StorageService from '@/services/StorageService';

class AuthService {
  resetAuthState = (): void => {
    StorageService.setValue(USER_AUTH_STATE_KEY, USER_AUTH_STATE_ANONYMOUS);
  };

  createAuthToken = (username: string, password: string): string => {
    return `Basic ${window.btoa(`${username}:${password}`)}`;
  };
}

const authService = new AuthService();

export default authService;
